import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core'
import { AppConfigService } from './services/app-config.service'

import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { CoreModule } from './core/core.module'
import { MainContainer } from './container/main/main.component'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { SelfServiceComponent } from './container/self-service/self-service.component'
import { QueueContainerComponent } from './container/queue-container/queue-container.component'
import { UnauthorizedComponent } from './unauthorized/unauthorized.component'
import { SettingsComponent } from './settings/settings.component'
import { MaterialModule } from './shared/material.module'
import { SharedModule } from './shared/shared.module'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { SettingsParamsComponent } from './settings/settings-params/settings-params.component'
import { SettingsSetoresComponent } from './settings/settings-totem/components/settings-setores/settings-setores.component'
import { SettingsAdsComponent } from './settings/settings-ads/settings-ads.component'
import { SettingsPainelComponent } from './settings/settings-painel/settings-painel.component'
import { SettingsTotemComponent } from './settings/settings-totem/settings-totem.component'
import { TotemSetoresComponent } from './settings/settings-totem/components/totem-setores/totem-setores.component'
import { AddPainelComponent } from './settings/settings-painel/components/add-painel/add-painel.component'
import { AddTotemComponent } from './settings/settings-totem/components/add-totem/add-totem.component'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { MatInputModule } from '@angular/material/input'
import { MatFormFieldModule } from '@angular/material/form-field'
import { CKEditorModule } from 'ckeditor4-angular'

@NgModule({
  declarations: [
    AppComponent,
    MainContainer,
    SelfServiceComponent,
    QueueContainerComponent,
    UnauthorizedComponent,
    SettingsComponent,
    SettingsParamsComponent,
    SettingsSetoresComponent,
    SettingsAdsComponent,
    SettingsPainelComponent,
    SettingsTotemComponent,
    TotemSetoresComponent,
    AddPainelComponent,
    AddTotemComponent,
  ],
  imports: [
    AppRoutingModule,
    CoreModule,
    BrowserAnimationsModule,
    MaterialModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatInputModule,
    MatFormFieldModule,
    CKEditorModule,
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    {
      provide: APP_INITIALIZER,
      useFactory: (configService: AppConfigService) => () => configService.loadConfig(),
      deps: [AppConfigService],
      multi: true
    }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
